<template>
  <div>
    <v-divider/>
    <v-list-group no-action sub-group :id="groupId">
      <template slot="activator">
        <v-list-tile>
          <v-list-tile-content>{{$t(`admin.alerts.new.placeholders.group.${placeholderGroup[placeholderKey].group}`)}}</v-list-tile-content>
        </v-list-tile>
      </template>
      <placeholder-item v-for="(p, i) in placeholderGroup" :key="i" :placeholder-key="i" :placeholder="p"/>
    </v-list-group>
  </div>
</template>
<script>
  import PlaceholderItem from './PlaceholderItem'

  export default {
    name: 'placeholder-group',
    components: {PlaceholderItem},
    props: {
      placeholderGroup: {
        type: Array
      },
      placeholderKey: {
        type: String
      }
    },
    computed: {
      groupId () {
        return `placeholder-group-${this.placeholderKey}`
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/settings/alert/PlaceholderGroup.vue